<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      sm="12"
      md="12"
      lg="12"
    >
      <b-overlay
        id="overlay-background-documents"
        :show="documentLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_DOCUMENTS') }}</b-card-title>
            <b-card-title class="text-primary">
              <b-button
                id="add-case-btn"
                v-b-modal.modal-add-other-files
                variant="primary"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_ADD_OTHER_FILES') }}</span>
              </b-button>
            </b-card-title>
          </b-card-header>
          <b-card-header
            class="base-document-header"
          >
            <b-button-group
              size="sm"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 1 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 1"
              >
                {{ $t('DEBTIA_ALL') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 2 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 2"
              >
                {{ $t('DEBTIA_UPLOADED') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                :class="baseDocumentType === 3 ? 'base-document-active-btn' : ''"
                @click="baseDocumentType = 3"
              >
                {{ $t('DEBTIA_PROCESSED') }}
              </b-button>
            </b-button-group>
          </b-card-header>
          <!-- client documents starts -->
          <div
            class="scroll-div-documents"
          >
            <b-table
              ref="roles"
              :fields="documentsTableFields"
              :items="allBaseDocuments"
              striped
              show-empty
              table-class="documents-table"
            >
              <template #head(checkbox)="">
                <b-form-checkbox
                  id="main_checkbox"
                  v-model="header_check"
                />
              </template>
              <template #empty="">
                <p>{{ $t('DEBTIA_NO_RECORD_FOUND') }}</p>
              </template>
              <template #cell(checkbox)="data">
                <b-form-checkbox
                  :id="`checkbox_${data.item.id}`"
                  v-model="baseDocumentVariables[`checkbox_${data.item.id}`].check"
                  @change="baseDocumentCheckBoxClicked($event, data.item.id)"
                />
              </template>
              <template #cell(category)="data">
                <span
                  v-b-tooltip.hover
                  class="documents-cell-truncate"
                  :title="data.item.category || data.item.template_name || 'N/A'"
                >
                  {{ data.item.category || data.item.template_name || 'N/A' }}
                </span>
              </template>
              <template #cell(title)="data">
                <span
                  v-b-tooltip.hover
                  class="documents-cell-truncate"
                  :title="data.item.title || data.item.document_name || 'N/A'"
                >
                  {{ data.item.title || data.item.document_name || 'N/A' }}
                </span>
              </template>
              <template #cell(file_link)="data">
                <feather-icon
                  v-if="data.item.file_link"
                  icon="ExternalLinkIcon"
                  size="18"
                  class="icon-styling"
                  @click="openLink(data.item.file_link)"
                />
                <span v-else>N/A</span>
              </template>
              <template #cell(payment_amount)="data">
                {{ data.item.payment_amount != null && data.item.payment_amount !== '' ? data.item.payment_amount : 'N/A' }}
              </template>
              <template #cell(vat_amount)="data">
                {{ data.item.vat_amount != null && data.item.vat_amount !== '' ? data.item.vat_amount : 'N/A' }}
              </template>
              <template #cell(paid_amount)="data">
                {{ data.item.paid_amount != null && data.item.paid_amount !== '' ? data.item.paid_amount : 'N/A' }}
              </template>
              <template #cell(uploaded_by)="data">
                {{ data.item.employee_name ? data.item.employee_name : 'N/A' }}
              </template>
              <template #cell(uploaded_at)="data">
                {{ data.item.uploaded_at ? (($i18n.locale === 'en') ? data.item.en_uploaded_at : data.item.da_uploaded_at) : 'N/A' }}
              </template>
              <template #cell(document_due_date)="data">
                {{ data.item.document_due_date || 'N/A' }}
              </template>
              <template #cell(document_send_date)="data">
                {{ data.item.document_send_date || 'N/A' }}
              </template>
              <template #cell(interest_rate_percentage)="data">
                <div v-if="data.item.category === 'Base Documents'">
                  {{ (data.item.interest_rate_agreed) ? data.item.interest_rate_percentage + '%' : data.item.interest_rate_percentage + '% standard process rente' }}
                  <feather-icon
                    v-b-modal.interest-rate-edit-modal
                    icon="Edit2Icon"
                    size="20"
                    class="edit-icon"
                    @click="editInterestRate(data.item)"
                  />
                </div>
                <div v-else>
                  -
                </div>
              </template>

              <template #cell(action)="data">
                <b-button
                  v-if="$ability.can(constants.action.permissionDeleteDebtCaseFile, constants.resource.user) && data.item.debt_stage === 'other_files'"
                  variant="gradient-danger"
                  class="btn-icon padding-1"
                  @click="confirmDeleteDocument(data.item.id, data.item.title)"
                >
                  <feather-icon
                    icon="XIcon"
                  />
                </b-button>
              </template>
            </b-table>
          </div>
          <div
            class="mt-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.base-documents-modal
              variant="primary"
              class="document-buttons"
              size="sm"
              :disabled="allBaseDocuments.length === 0"
              @click="downloadAllFiles(), checkAll = true"
            >
              {{ $t('DEBTIA_DOWNLOAD_ALL_FILES') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.base-documents-modal
              variant="primary"
              class="document-buttons"
              size="sm"
              :disabled="allBaseDocuments.length === 0 || selectedBaseDocuments.length === 0"
              @click="downloadSelectedFiles(), checkAll = false"
            >
              {{ $t('DEBTIA_DOWNLOAD_SELECTED_FILES') }}
            </b-button>
            <b-button
              v-if="$ability.can(constants.action.permissionDeleteDebtCaseFile, constants.resource.user)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="document-buttons"
              size="sm"
              :disabled="allBaseDocuments.length === 0 || selectedDeletableDocuments.length === 0"
              @click="deleteConfirmationPopup"
            >
              {{ $t('DEBTIA_DELETE_SELECTED_FILES') }}
            </b-button>
          </div>
        </b-card>
      </b-overlay>
      <base-documents-modal
        :base-documents-categories="baseDocumentsCategories"
        :base-document-templates="baseDocumentTemplates"
        :selected-base-documents="selectedBaseDocuments"
        :all-base-documents="allBaseDocuments"
        :check-all="checkAll"
        :refresh-checkboxes="refreshCheckboxes"
      />
      <other-files-modal
        :get-details="getDocuments"
        :case-id="caseID"
      />
      <interest-rate-edit-modal
        :selected-document-data="selectedDocumentData"
        :get-documents="getDocuments"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BTable, BButton, BButtonGroup, BFormCheckbox, BOverlay, VBTooltip,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import axios from '@axios'
import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'
import BaseDocumentsModal from '../BaseDocumentsModal.vue'
import OtherFilesModal from '../OtherFilesModal.vue'
import InterestRateEditModal from './InterestRateEditModal.vue'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // DragLinks,
    BButton,
    BButtonGroup,
    BFormCheckbox,
    BaseDocumentsModal,
    BOverlay,
    OtherFilesModal,
    InterestRateEditModal,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      documentLoader: true,
      header_check: false,
      baseDocumentType: 1,
      allBaseDocuments: [],
      processedLetters: [],
      baseDocumentVariables: {},
      selectedBaseDocuments: [],
      selectedDeletableDocuments: [],
      baseDocumentsCategories: [],
      baseDocumentTemplates: [],
      creditNotes: [],
      debtReminders: [],
      otherFiles: [],
      letterFiles: [],
      documentsData: [],
      caseID: this.$route.params.id,
      allDocumentsData: [],
      constants,
      lltter: 0,
      checkAll: false,
      selectedDocumentData: [],
      enableColumns: [],
    }
  },
  computed: {
    tableFields() {
      return [
        {
          key: 'category', sortable: true, label: i18n.t('DEBTIA_CATEGORY'), tdClass: 'text-capitalize',
        },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'uploaded_at', sortable: true, label: i18n.t('DEBTIA_UPLOAD_DATE') },
        { key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'uploaded_by', sortable: true, label: i18n.t('DEBTIA_UPLOADED_BY') },
        { key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT') },
        { key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE') },
        { key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE') },
        { key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE') },
      ]
    },
    documentsTableFields() {
      const alwaysVisible = ['checkbox']
      const enabled = new Set([...alwaysVisible, ...(this.enableColumns || [])])

      const compactCol = { thClass: 'documents-col-compact', tdClass: 'documents-col-compact' }

      return [
        { key: 'checkbox', thClass: 'documents-col-checkbox', tdClass: 'documents-col-checkbox' },
        {
          key: 'action', sortable: true, label: i18n.t('DEBTIA_ACTION'), ...compactCol,
        },
        {
          key: 'category',
          sortable: true,
          label: i18n.t('DEBTIA_CATEGORY_TEMPLATE'),
          tdClass: 'text-capitalize documents-col-category',
          thClass: 'documents-col-category',
        },
        {
          key: 'title',
          sortable: true,
          label: i18n.t('DEBTIA_TITLE'),
          tdClass: 'documents-col-title',
          thClass: 'documents-col-title',
        },
        {
          key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK'), ...compactCol,
        },
        {
          key: 'uploaded_at', sortable: true, label: i18n.t('DEBTIA_UPLOAD_DATE'), ...compactCol,
        },
        {
          key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT'), ...compactCol,
        },
        {
          key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT'), ...compactCol,
        },
        {
          key: 'uploaded_by', sortable: true, label: i18n.t('DEBTIA_UPLOADED_BY'), ...compactCol,
        },
        {
          key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT'), ...compactCol,
        },
        {
          key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE'), ...compactCol,
        },
        {
          key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE'), ...compactCol,
        },
        {
          key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE'), ...compactCol,
        },
        // { key: 'document_name', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_NAME') },
      ].filter(field => enabled.has(field.key))
    },
    letterFilesCount() {
      // Access the letterFiles property from the store and compute its length
      return this.$store.state['case-details'].letterFiles.propertyA
    },
  },
  watch: {
    baseDocumentType: {
      handler() {
        this.documentLoader = true
        this.allBaseDocuments = []
        if (this.selectedBaseDocuments.length > 0) {
          this.selectedBaseDocuments.forEach(element => {
            this.baseDocumentVariables[`checkbox_${element}`].check = false
          })
        }
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      },
    },
    header_check: {
      handler() {
        this.baseDocumentsCategories = []
        this.baseDocumentTemplates = []
        this.selectedBaseDocuments = []
        this.selectedDeletableDocuments = []
        Object.keys(this.baseDocumentVariables).forEach(element => {
          this.baseDocumentVariables[element].check = this.header_check
          this.categoryCheck(this.header_check, this.baseDocumentVariables[element].id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
          if (this.header_check) {
            this.selectedBaseDocuments.push(this.baseDocumentVariables[element].id)
            if (this.baseDocumentVariables[element].debt_stage === 'other_files') {
              this.selectedDeletableDocuments.push(this.baseDocumentVariables[element].id)
            }
          }
        })
      },
    },
  },
  created() {
    EventBus.$on('refreshDocuments', () => {
      this.getDocuments()
    })
  },
  methods: {
    async fetchInitialData() {
      await this.getDocuments()
    },
    async getDocuments() {
      this.documentLoader = true
      const url = `${constants.baseUrlV2}/debt-case/docs-data/${this.caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.baseDocuments = response.data.data.base_documents
          this.creditNotes = response.data.data.credit_notes
          this.debtReminders = response.data.data.debt_reminders
          this.otherFiles = response.data.data.other_files
          this.letterFiles = response.data.data.letter_files
          this.enableColumns = response.data.enableColumns
          this.addProcessedLettersForBaseDocuments(this.letterFiles)
          this.getCurrentBaseDocuments(1)
          this.documentLoader = false
        }
      })
    },
    getCurrentBaseDocuments(type) {
      this.header_check = false
      if (type === 2) {
        this.allBaseDocuments = [...this.baseDocuments, ...this.creditNotes, ...this.debtReminders, ...this.otherFiles]
      } else if (type === 3) {
        this.allBaseDocuments = [...this.processedLetters]
      } else {
        this.allBaseDocuments = [...this.baseDocuments, ...this.creditNotes, ...this.debtReminders, ...this.otherFiles, ...this.processedLetters]
      }
      this.makeVariableForBaseDocuments(this.allBaseDocuments)
    },
    addProcessedLettersForBaseDocuments(letters) {
      this.processedLetters = []
      letters.forEach(element => {
        const obj = {
          id: element.id,
          category: null,
          category_id: null,
          debt_stage: 'letter_files',
          title: element.document_name || element.title,
          file_link: element.file_link,
          document_due_date: '',
          document_send_date: '',
          interest_rate_agreed: '',
          interest_rate_percentage: '',
          paid_amount: '',
          payment_amount: '',
          rest_amount: '',
          total_amount: '',
          vat_amount: '',
          template_name: element.title,
          template_id: element.letter_template_id,
          uploaded_at: element.uploaded_at || element.created_at || '',
          en_uploaded_at: element.en_uploaded_at || '',
          da_uploaded_at: element.da_uploaded_at || '',
          document_name: element.document_name,
        }
        this.processedLetters.push(obj)
      })
    },
    makeVariableForBaseDocuments(documents) {
      this.baseDocumentVariables = {}
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
      documents.forEach(element => {
        this.baseDocumentVariables[`checkbox_${element.id}`] = {
          id: element.id,
          check: false,
          category: element.category ? this.capitalizeWords(element.category) : null,
          category_id: element.category_id,
          debt_stage: element.debt_stage,
          title: element.title,
          template_name: element.template_name,
          template_id: element.template_id,
        }
      })
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    baseDocumentCheckBoxClicked(value, id) {
      if (value) {
        this.selectedBaseDocuments.push(id)
        if (this.baseDocumentVariables[`checkbox_${id}`].debt_stage === 'other_files') {
          this.selectedDeletableDocuments.push(id)
        }
      } else {
        // to remove the checkbox id
        const indexToRemove = this.selectedBaseDocuments.indexOf(id)
        if (indexToRemove !== -1) {
          this.selectedBaseDocuments.splice(indexToRemove, 1)
        }
        const deleteIndexToRemove = this.selectedDeletableDocuments.indexOf(id)
        if (deleteIndexToRemove !== -1) {
          this.selectedDeletableDocuments.splice(deleteIndexToRemove, 1)
        }
      }
    },
    capitalizeWords(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase())
    },
    confirmDeleteDocument(id, title) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: `${i18n.t('DEBTIA_DELETING_FILE_TEXT')} ${title}. ${i18n.t('DEBTIA_REVERT_MSG')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.selectedDeletableDocuments = []
          this.selectedBaseDocuments = []
          this.selectedDeletableDocuments.push(id)
          this.selectedBaseDocuments.push(id)
          this.deleteFiles()
        }
      })
    },
    downloadAllFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      Object.keys(this.baseDocumentVariables).forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[element].category_id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
      })
    },
    downloadSelectedFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      this.selectedBaseDocuments.forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[`checkbox_${element}`].category_id, this.baseDocumentVariables[`checkbox_${element}`].category, this.baseDocumentVariables[`checkbox_${element}`].template_id, this.baseDocumentVariables[`checkbox_${element}`].template_name, this.baseDocumentVariables[`checkbox_${element}`].debt_stage)
      })
    },
    categoryCheck(check, categoryId, categoryName, templateId, templateName, debtStage) {
      if (categoryName === 'Base Documents' || categoryName === 'Credit Notes' || categoryName === 'Debt Reminders' || categoryName === 'Processed Letters') {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId && item.name === categoryName)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (categoryId) {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (templateId) {
        const foundTemplate = this.baseDocumentTemplates.findIndex(item => item.id === templateId)
        // const categoryToRemove = this.baseDocumentsCategories.indexOf(this.capitalizeWords(category))
        const obj = {
          id: templateId,
          name: templateName,
          debt_stage: debtStage,
        }
        if (check && foundTemplate === -1) {
          this.baseDocumentTemplates.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundTemplate !== -1) {
          this.baseDocumentTemplates.splice(foundTemplate, 1)
        }
      }
    },
    deleteConfirmationPopup() {
      let titles = ''
      this.selectedDeletableDocuments.forEach(element => {
        titles += `${this.baseDocumentVariables[`checkbox_${element}`].title}<br>`
      })
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_SURE_REVERT_MSG'),
        icon: 'warning',
        html:
          `${i18n.t('DEBTIA_FILE_DELETION_MSG')}: <br>${titles}${i18n.t('DEBTIA_SURE_REVERT_MSG')}`,
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES_DELETE_IT_1'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteFiles()
        }
      })
    },
    async deleteFiles() {
      const filesData = []
      this.selectedBaseDocuments.forEach(element => {
        const filteredObj = this.allBaseDocuments.filter(documentelement => element === documentelement.id)
        filesData.push(filteredObj[0])
      })
      const obj = {
        debt_case_id: this.caseID,
        ids: this.selectedDeletableDocuments,
        files_data: filesData,
      }
      await axios.post('/delete-debt-case-file', obj).then(responseLocal => {
        if (responseLocal.status) {
          this.refreshCheckboxes()
          this.getDocuments()
          this.processedLetters = []
          EventBus.$emit('refreshLogs')
          EventBus.$emit('refreshModules')
          EventBus.$emit('refreshSecondaryProcesses')
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: i18n.t('DEBTIA_FILE_DELETION_MSG'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }).catch(err => {
        this.loader = false
        this.alertErrors = [...err.response.data.message]
      })
    },
    refreshCheckboxes() {
      // this.baseDocumentVariables.checkbox_5924.check = false
      if (this.header_check) {
        this.header_check = false
      } else if (this.selectedBaseDocuments.length > 0) {
        this.documentLoader = true
        this.allBaseDocuments = []
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      }
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
    },
    editInterestRate(data) {
      this.selectedDocumentData = [data]
      this.$root.$emit('bv::show::modal', 'interest-rate-edit-modal')
    },
  },
}
</script>

<style lang="scss">

.document-buttons {
    margin-right: 5px;
  }

  .padding-1 {
    padding: 1px !important;
  }

  .icon-styling {
    cursor: pointer;
  }
.scroll-div-documents {
  overflow-x: auto;
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 350px;
  padding-right: 10px;

  .documents-table {
    width: auto;
    min-width: 100%;
    table-layout: auto;

    .documents-col-compact {
      width: 1%;
      white-space: nowrap;
    }

    .documents-col-category {
      width: 10rem;
      max-width: 10rem;
      overflow: hidden;
    }

    .documents-col-title {
      width: 14rem;
      max-width: 14rem;
      overflow: hidden;
    }

    .documents-cell-truncate {
      display: block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .documents-col-checkbox {
      width: 60px;
      white-space: nowrap;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
}

.scroll-div-documents::-webkit-scrollbar {
    width: 12px;
}

.scroll-div-documents::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div-documents::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
.edit-icon{
  margin-left: 8px;
}
</style>
